export enum LOCAL_STORAGE_KEYS_NAMES {
    SHOP_ID = "shop_id"
}
